var map = {
	"./16/check.svg": 5366,
	"./16/circle.svg": 4603,
	"./16/clock.svg": 6298,
	"./20/chevron-left.svg": 7809,
	"./20/chevron-right.svg": 3590,
	"./20/cross.svg": 909,
	"./20/play.svg": 5255,
	"./24/call.svg": 928,
	"./24/chevron-down.svg": 2008,
	"./24/chevron-left.svg": 3428,
	"./24/chevron-right.svg": 2117,
	"./24/chevron-up.svg": 7719,
	"./24/cross.svg": 5062,
	"./24/external.svg": 1898,
	"./24/info.svg": 6999,
	"./24/link.svg": 9306,
	"./24/minus.svg": 7397,
	"./24/play.svg": 857,
	"./24/plus.svg": 4012,
	"./24/rewind-left.svg": 5360,
	"./24/rewind-right.svg": 8842,
	"./24/spinner.svg": 8913,
	"./24/wave.svg": 2467,
	"./32/pause.svg": 9243,
	"./32/play.svg": 4474,
	"./logo/logo.svg": 4730,
	"./mood/1.svg": 6326,
	"./mood/2.svg": 5333,
	"./mood/3.svg": 853,
	"./mood/4.svg": 4648,
	"./mood/5.svg": 6745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;